import { InstalledSensorStatus } from '@/core/models/types'

// Single source of truth for sensor-status colours, shared by the Plant Status
// donut/legend and the Sensor Overview status icons so the two stay consistent.
export const STATUS_COLORS: Record<InstalledSensorStatus, string> = {
    [InstalledSensorStatus.Offline]: '#c6002d',
    [InstalledSensorStatus.Unsuccessful]: '#a34e00',
    [InstalledSensorStatus.Prepared]: '#e89959',
    [InstalledSensorStatus.Draft]: '#0070a9',
    [InstalledSensorStatus.Active]: '#7cc278',
    [InstalledSensorStatus.Onboarded]: '#7cc278',
    [InstalledSensorStatus.Deleted]: '#4c4c4c',
    [InstalledSensorStatus.Start]: '#4c4c4c',
}
